import { VERIFY_THE1, VERIFY_THE1_ERROR, REGISTER_TRANSFER, REGISTER_TRANSFER_ERROR } from '../actions/the1/type'
import _ from 'lodash'

const initState = {verifyResult: null, cards: [], registerResult: null, registerMessage: null}
export default function(state = initState, action) {
    switch(action.type) {
        case VERIFY_THE1: 
            const cards = [];
            let verifyResult = false, verifyError = null
            if (action.payload && action.payload.responseBody) {
                verifyResult = true
                const {members} = action.payload.responseBody
                if (members) {
                    _.each(members, (member) => {
                        _.each(member.cards, (card) => {
                            const mem = {first_name: {en: member.memberFirstNameEng, th: member.memberFirstNameThai}, last_name: {en: member.memberLastNameEng, th: member.memberLastNameThai}}
                            const cardWithMember = Object.assign(mem, card)
                            cards.push(cardWithMember)
                        })
                    })
                }
            } else if (action.payload && (action.payload.integrationStatusCode === "2_CRC_ERR_MEMBER" || action.payload.integrationStatusCode === "CRC_ERR_MEMBER") ){
                verifyResult = false
                verifyError = "ไม่พบข้อมูลลูกค้า โปรดตรวจสอบข้อมูลหรือติดต่อ The 1 Call center (02-660-1000)"
            }
            return {...state, verifyResult, cards, verifyError}
        case VERIFY_THE1_ERROR:
            return {...state, verifyResult: false, verifyError: action.payload, cards: []}
        case REGISTER_TRANSFER:
            return {...state, registerResult: action.payload, registerMessage: null}
        case REGISTER_TRANSFER_ERROR:
            return {...state, registerResult: false, registerMessage: action.payload}
        default: 
            return state;
    }
}